module.exports = __webpack_public_path__ + "static/profile-pic-7c4b38670fbe01f6754e8d67a0e1cb41.jpg";